import {UmpireClub} from '../umpire-club';
import {UmpireImage} from '../umpire-image';
import {UmpirePlayer} from '../umpire-player';
import {UmpireVisibilityOption} from '../umpire-visibility-options';

export interface UmpireSurvey {
  id?: string | null;
  answers_type: UmpireSurveyAnswersType | null;
  name: string;
  image: UmpireImage | null;
  question: string;
  end_time: string | null;
  visibility: UmpireVisibilityOption[] | null;
  is_draft: boolean;
  publication_time: string | null;
  published_at: string | null;
  answers: UmpireSurveyAnswer[];
  type: 'survey';
  relationshipNames: string[];
  total_answers_count?: number;
  status?: 'active' | 'ended';
  user_answer?: {
    answer: UmpireSurveyAnswer;
  };
}

export enum UmpireSurveyAnswersType {
  'text' = 'text',
  'player' = 'player',
  'club' = 'club',
}

export interface UmpireSurveyAnswer {
  id: string | null;
  content?: string;
  type: 'answer';
  image?: UmpireImage | null;
  resource?: UmpireClub | UmpirePlayer | null;
  relationshipNames: string[];
  answers_count: number;
}
